var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showPlaceholderLabel
        ? _c("label", { staticClass: "d-block" }, [_vm._v(" ")])
        : _vm._e(),
      _c(
        "b-form-group",
        {
          attrs: {
            id: _vm.id,
            label: _vm.currentLabel,
            "label-for": `${_vm.id}-input`,
            "content-cols": "auto",
          },
        },
        [
          _c(
            "b-input-group",
            { class: _vm.inputGroupSize },
            [
              _c(
                "c-switch",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: {
                        id: `${_vm.id}-input`,
                        color: "primary",
                        label: "",
                        readonly: _vm.readonly,
                        disabled: _vm.disabled,
                        title: _vm.tooltip,
                      },
                      model: {
                        value: _vm.innerValue,
                        callback: function ($$v) {
                          _vm.innerValue = $$v
                        },
                        expression: "innerValue",
                      },
                    },
                    "c-switch",
                    _vm.labelIcon,
                    false
                  ),
                  _vm.inputListeners
                )
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }